<template>
  <page>
    <loading :active.sync="isProcessing"></loading>

    <div class="checkout-form">

      <div class="mt-5">
        <h2 class="font-weight-bold">
          File IRS Form 4868 - Extension Request
        </h2>
      </div>

      <div class="mt-4 mb-1 ml-2 mr-2 panel-between-desc">
        <div class="form-title mb-1">Taxpayer Information</div>
      </div>

      <div class="panel">
        <ValidationObserver ref="form1">
          <form>
            <div class="row">
              <div class="form-group col-12 col-md-4">
                <label>First Name</label>
                <ValidationProvider
                  name="The first name"
                  rules="required|allowed_str"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    :class="
                      'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                    "
                    placeholder="First Name"
                    v-model="orderInfo.firstName"
                    @blur="onCheckStep1"
                  />
                  <span class="ein-form-err">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>Middle Name</label>
                <ValidationProvider
                  name="The middle name"
                  rules="allowed_str"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    :class="
                      'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                    "
                    placeholder="Middle Name"
                    v-model="orderInfo.middleName"
                    @blur="onCheckStep1"
                  />
                  <span class="ein-form-err">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group col-12 col-md-4">
                <label>Last Name</label>
                <ValidationProvider
                  name="The last name"
                  rules="required|allowed_str"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    :class="
                      'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                    "
                    placeholder="Last Name"
                    v-model="orderInfo.lastName"
                    @blur="onCheckStep1"
                  />
                  <span class="ein-form-err">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12 col-md-4">
                <label>Social Security Number/TIN</label>
                <ValidationProvider
                  name="The SSN/TIN"
                  rules="required|ssn_tin"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    :class="
                      'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                    "
                    placeholder="000-00-0000"
                    v-model="orderInfo.ssn"
                    v-mask="'###-##-####'"
                    @blur="onCheckStep1"
                  />
                  <span class="ein-form-err">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="col-12 col-md-4">
                <label class="form-control-label light-gray">Birth Date</label>
                <ValidationProvider
                  name="The birth date"
                  rules="required|birth_date|age_limit"
                  v-slot="{ errors }"
                >
                  <input
                    :class="['form-control', errors.length > 0 ? 'is-invalid' : '']"
                    type="text"
                    v-model="orderInfo.birthDate"
                    placeholder="MM/DD/YYYY"
                    maxlength="10"
                    v-mask="'##/##/####'"
                    @blur="onCheckStep1"
                  />
                  <span class="ein-form-err">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

            </div>

            <div class="form-group">
              <label>Email</label>
              <ValidationProvider
                name="The email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <input
                  type="text"
                  :class="
                    'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                  "
                  placeholder="mail@email.com"
                  v-model="orderInfo.email"
                  @blur="onCheckStep1"
                />
                <span class="ein-form-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="custom-control custom-checkbox custom-checkbox-green mb-3">
              <input
                class="custom-control-input custom-control-input-green"
                type="checkbox"
                id="married"
                name="married"
                v-model="orderInfo.married"
              />
              <label class="custom-control-label" for="married">
                Are you married?
              </label>
            </div>

            <div v-if="orderInfo.married">
              <div class="row">
                <div class="form-group col-12 col-md-4">
                  <label>Spouse First Name</label>
                  <ValidationProvider
                    name="The spouse first name"
                    rules="required|allowed_str"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      :class="
                        'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                      "
                      placeholder="Spouse First Name"
                      v-model="orderInfo.spouseFirstName"
                      @blur="onCheckStep1"
                    />
                    <span class="ein-form-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group col-12 col-md-4">
                  <label>Spouse Middle Name</label>
                  <ValidationProvider
                    name="The spouse middle name"
                    rules="allowed_str"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      :class="
                        'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                      "
                      placeholder="Spouse Middle Name"
                      v-model="orderInfo.spouseMiddleName"
                      @blur="onCheckStep1"
                    />
                    <span class="ein-form-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group col-12 col-md-4">
                  <label>Spouse Last Name</label>
                  <ValidationProvider
                    name="The spouse last name"
                    rules="required|allowed_str"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      :class="
                        'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                      "
                      placeholder="Spouse Last Name"
                      v-model="orderInfo.spouseLastName"
                      @blur="onCheckStep1"
                    />
                    <span class="ein-form-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-12 col-md-4">
                  <label>Spouse SSN/TIN</label>
                  <ValidationProvider
                    name="The Spouse SSN/TIN"
                    rules="required|ssn_tin"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      :class="
                        'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                      "
                      placeholder="000-00-0000"
                      v-model="orderInfo.spouseSsn"
                      v-mask="'###-##-####'"
                      @blur="onCheckStep1"
                    />
                    <span class="ein-form-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="col-12 col-md-4">
                  <label class="form-control-label light-gray">Spouse Birth Date</label>

                  <ValidationProvider
                    name="The spouse birth date"
                    rules="required|birth_date|age_limit"
                    v-slot="{ errors }"
                  >
                    <input
                      :class="['form-control', errors.length > 0 ? 'is-invalid' : '']"
                      type="text"
                      v-model="orderInfo.spouseBirthDate"
                      placeholder="MM/DD/YYYY"
                      maxlength="10"
                      v-mask="'##/##/####'"
                      @blur="onCheckStep1"
                    />
                    <span class="ein-form-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>

            <div class="custom-control custom-checkbox custom-checkbox-green">
              <input
                class="custom-control-input custom-control-input-green"
                type="checkbox"
                id="abroad"
                name="abroad"
                v-model="orderInfo.abroad"
              />
              <label class="custom-control-label" for="abroad">
                Are you a US Citizen or Resident currently located outside the country?
              </label>
            </div>
          </form>
        </ValidationObserver>
      </div>

      <div class="mt-4 mb-1 ml-2 mr-2 panel-between-desc">
        <div class="form-title mb-1">Address Information</div>
      </div>

      <div class="panel">
        <ValidationObserver ref="form2">
          <form>
            <div class="form-group">
              <label>Street</label>

              <ValidationProvider
                name="The street"
                rules="required"
                v-slot="{ errors }"
              >
                <vue-google-autocomplete
                  id="gaddress"
                  ref="address"
                  :class="[
                    'form-control',
                    errors.length > 0 ? 'is-invalid' : '',
                  ]"
                  placeholder="Street"
                  v-model="orderInfo.address1"
                  @placechanged="getAddressData"
                  @blur="extractAddress"
                  @inputChange="setAddress"
                  country="US"
                >
                </vue-google-autocomplete>
                <span class="ein-form-err">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <label>Apt/Unit</label>
              <input
                type="text"
                class="form-control"
                placeholder="Apt/Unit"
                v-model="orderInfo.address2"
                @blur="onCheckStep2"
              />
            </div>

            <div class="form-group mt-1">
              <label>City</label>
              <ValidationProvider
                name="The city"
                rules="required|allowed_str"
                v-slot="{ errors }"
              >
                <input
                  type="text"
                  :class="[
                    'form-control',
                    errors.length > 0 ? 'is-invalid' : '',
                  ]"
                  placeholder="City"
                  v-model="orderInfo.city"
                  @blur="onCheckStep2"
                />
                <span class="ein-form-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>State</label>
              <ValidationProvider
                name="The state"
                rules="required|allowed_str"
                v-slot="{ errors }"
              >
                <select
                  :class="[
                    'form-control',
                    errors.length > 0 ? 'is-invalid' : '',
                  ]"
                  v-model="orderInfo.state"
                  @blur="onCheckStep2"
                >
                  <option value="" style="font-style: italic; color: gray">
                    State
                  </option>
                  <option
                    v-for="(s, i) in states"
                    :key="i"
                    :value="s.abbreviation"
                  >
                    {{ s.name }}
                  </option>
                </select>
                <span class="ein-form-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>Zip Code</label>
              <ValidationProvider
                name="The zip code"
                rules="required|zip_code"
                v-slot="{ errors }"
              >
                <input
                  type="text"
                  :class="[
                    'form-control',
                    errors.length > 0 ? 'is-invalid' : '',
                  ]"
                  placeholder="Zip Code"
                  v-model="orderInfo.zip"
                  @blur="onCheckStep2"
                />
                <span class="ein-form-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </form>
        </ValidationObserver>
      </div>

      <div class="mt-4 mb-1 ml-2 mr-2 panel-between-desc">
        <div class="form-title mb-1">Tax Information</div>
      </div>

      <div class="panel">
        <ValidationObserver ref="form3">
          <form>

            <div class="form-group">
              <label>
                What do you estimate your total tax liability is for {{currentYear - 1}}?
              </label>

              <ValidationProvider
                name="The total liability"
                rules="required|min_value:0.00"
                v-slot="{ errors }"
              >
                <input
                  type="number"
                  :class="
                    'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                  "
                  v-model="orderInfo.totalLiability"
                  placeholder="1000"
                  inputmode="decimal"
                  @blur="onCheckStep3"
                />
                <span class="ein-form-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <label>
                How many tax payments did you make in {{currentYear - 1}}?
              </label>

              <ValidationProvider
                name="The total payments"
                rules="required|min_value:0.00"
                v-slot="{ errors }"
              >
                <input
                  type="number"
                  :class="
                    'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                  "
                  v-model="orderInfo.totalPayments"
                  placeholder="1000"
                  inputmode="decimal"
                  @blur="onCheckStep3"
                />
                <span class="ein-form-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <label>
                Estimated Balance Due: <b>${{getBalanceDue(orderInfo)}}</b>
              </label>
            </div>

            <div class="form-group">
              <p>
                <font-awesome-icon icon="circle-check" />
                To e-file your application, the IRS requires just one of the following from last year
                <span v-b-popover.hover.bottom="
                  'You only need to fill in one. We’ll use whichever one you provide.'
                ">
                  <font-awesome-icon icon="circle-question" class="help-color"/>
                </span>
              </p>

              <div class="row">
                <div class="col-12 col-sm-6">
                  <label class="form-control-label light-gray"><b>Option 1:</b> Prior Year AGI
                    <span v-b-popover.hover.bottom="'You’ll find Adjusted Gross Income (AGI) on line 11 of last year’s Form 1040'">
                      <font-awesome-icon icon="circle-question" class="help-color"/>
                    </span>
                  </label>
                  <input
                    :class="['form-control', error.priorYearAgi ? 'is-invalid' : '']"
                    type="text"
                    v-model="orderInfo.priorYearAgi"
                    placeholder="Adjusted Gross Income (AGI) from last tax return"
                    inputmode="decimal"
                    v-on:input="restrictAgi"
                    :disabled="isPinSelected"
                    @focus="handleAgiFocus"
                  />

                  <div
                    v-if="error.priorYearAgi"
                    class="text-danger"
                    style="margin-top: 2px"
                  >
                    {{ error.priorYearAgi }}
                  </div>
                </div>
                <div style="font-weight: bolder; font-size: large;padding-top: 15px" class="col-12 col-sm-1">
                  or
                </div>
                <div class="col-12 col-sm-5">
                  <label class="form-control-label light-gray"><b>Option 2:</b> Self-Select PIN
                    <span
                      v-b-popover.hover.bottom="'This is the 5-digit PIN you or your accountant created last time you e-filed'">
                  <font-awesome-icon icon="circle-question" class="help-color"/>
                    </span>
                  </label>
                  <input
                    :class="['form-control', error.priorYearPin ? 'is-invalid' : '']"
                    type="number"
                    v-model="orderInfo.priorYearPin"
                    placeholder="5-digit PIN"
                    :maxlength="5"
                    v-mask="'#####'"
                    v-on:input="checkPin"
                    :disabled="isAgiSelected"
                    @focus="handlePinFocus"
                  />

                  <div
                    v-if="error.priorYearPin"
                    class="text-danger"
                    style="margin-top: 2px"
                  >
                    {{ error.priorYearPin }}
                  </div>
                </div>
              </div>
              <p class="text-entered" v-if="isPinSelected || isAgiSelected">
                <br/>
                You’ve already provided what we need.
              </p>

              <div v-if="orderInfo.married" class="mt-3">
                <p>
                  <font-awesome-icon icon="circle-check" /> Same way, please fill in one of the following from last year for your spouse
                </p>

                <div class="row">
                  <div class="col-12 col-sm-6">
                    <label class="form-control-label light-gray"><b>Option 1:</b> Spouse Prior Year AGI
                      <span v-b-popover.hover.bottom="'You’ll find Adjusted Gross Income (AGI) on line 11 of spouse’s last year’s Form 1040'">
                        <font-awesome-icon icon="circle-question" class="help-color"/>
                      </span>
                    </label>
                    <input
                      :class="['form-control', error.spousePriorYearAgi ? 'is-invalid' : '']"
                      type="text"
                      v-model="orderInfo.spousePriorYearAgi"
                      placeholder="Spouse's Adjusted Gross Income (AGI) from last tax return"
                      inputmode="decimal"
                      v-on:input="restrictSpouseAgi"
                      :disabled="isSpousePinSelected"
                      @focus="handleSpouseAgiFocus"
                    />

                    <div
                      v-if="error.spousePriorYearAgi"
                      class="text-danger"
                      style="margin-top: 2px"
                    >
                      {{ error.spousePriorYearAgi }}
                    </div>
                  </div>

                  <div style="font-weight: bolder; font-size: large;padding-top: 15px" class="col-12 col-sm-1">
                    or
                  </div>

                  <div class="col-12 col-sm-5">
                    <label class="form-control-label light-gray"><b>Option 2:</b> Spouse Self-Select PIN
                      <span
                        v-b-popover.hover.bottom="'This is the 5-digit PIN your spouse created last time your spouse e-filed'">
                        <font-awesome-icon icon="circle-question" class="help-color"/>
                      </span>
                    </label>
                    <input
                      :class="['form-control', error.spousePriorYearPin ? 'is-invalid' : '']"
                      type="number"
                      v-model="orderInfo.spousePriorYearPin"
                      placeholder="Spouse's 5-digit PIN"
                      v-on:input="checkSpousePin"
                      :disabled="isSpouseAgiSelected"
                      @focus="handleSpousePinFocus"
                    />

                    <div
                      v-if="error.spousePriorYearPin"
                      class="text-danger"
                      style="margin-top: 2px"
                    >
                      {{ error.spousePriorYearPin }}
                    </div>
                  </div>
                </div>
                <p class="text-entered" v-if="isSpousePinSelected || isSpouseAgiSelected">
                  <br/>
                  You’ve already provided what we need.
                </p>

              </div>
            </div>

            <div class="custom-control custom-checkbox custom-checkbox-green mb-3" v-if="getBalanceDue(orderInfo) > 0">              <input
                class="custom-control-input custom-control-input-green"
                type="checkbox"
                id="schedulePayment"
                name="schedulePayment"
                v-model="orderInfo.schedulePayment"
              />
              <label class="custom-control-label" for="schedulePayment">
                Would you like to schedule an EFW (Electronic Funds Withdrawal) payment with the IRS?
              </label>
            </div>

            <div v-if="orderInfo.schedulePayment">
              <div class="form-group">
                <label>Routing Number</label>
                <ValidationProvider
                  name="The routing number"
                  rules="required|routing_transit"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    :class="
                      'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                    "
                    placeholder="012345678"
                    v-model="orderInfo.routingTransitNumber"
                    v-mask="'#########'"
                    @blur="onCheckStep3"
                  />
                  <span class="ein-form-err">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="row">
                <div class="form-group col-12 col-sm-6">
                  <label>Account Number</label>
                  <ValidationProvider
                    name="The account number"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      :class="
                        'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                      "
                      placeholder="1234567000"
                      v-model="orderInfo.bankAccountNumber"
                      :maxlength="17"
                      @blur="onCheckStep3"
                    />
                    <span class="ein-form-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group col-12 col-sm-6">
                  <label>Account Type</label>
                  <ValidationProvider
                    name="The account type"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <select
                      :class="[
                        'form-control',
                        errors.length > 0 ? 'is-invalid' : '',
                      ]"
                      v-model="orderInfo.bankAccountType"
                      @blur="onCheckStep3"
                    >
                      <option value="" style="font-style: italic; color: gray">
                        Type
                      </option>
                      <option
                        v-for="(type, i) in accountTypes"
                        :key="i"
                        :value="type.value"
                      >
                        {{ type.name }}
                      </option>
                    </select>
                    <span class="ein-form-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-12 col-sm-6">
                  <label>Payment Amount</label>

                  <ValidationProvider
                    name="The payment amount"
                    rules="required|min_value:1.00"
                    v-slot="{ errors }"
                  >
                    <input
                      type="number"
                      :class="
                        'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                      "
                      v-model="orderInfo.paymentAmount"
                      placeholder="1000"
                      inputmode="decimal"
                      @blur="onCheckStep3"
                    />
                    <span class="ein-form-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group col-12 col-sm-6">
                  <label>Scheduled Payment Date (April 15 or earlier)</label>

                  <ValidationProvider
                    name="The payment date"
                    rules="required|mm_dd_0415"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      :class="
                        'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                      "
                      placeholder="MM-DD"
                      v-model="orderInfo.paymentDate"
                      v-mask="'##-##'"
                      @blur="onCheckStep3"
                    />
                    <span class="ein-form-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="form-group">
                <label>Phone Number</label>
                <ValidationProvider
                  name="The phone number"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    :class="
                      'form-control ' + (errors.length > 0 ? ' is-invalid' : '')
                    "
                    placeholder="123-456-7890"
                    v-model="orderInfo.phone"
                    v-mask="'###-###-####'"
                    @blur="onCheckStep3"
                  />
                  <span class="ein-form-err">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

            </div>
          </form>
        </ValidationObserver>
      </div>

      <div class="mt-4 panel">
        <div class="the-title mb-3">
          Form 4868
          <img src="@/assets/payment/irs-efile.png"
            style="max-width: 90px; margin-top: -5px; margin-left: 5px;"/>
        </div>

        <div class="the-sub-title mb-3">We will E-file Form 4868 - Extension to File with the IRS</div>

        This form will give you an <b>automatic 6-month extension</b> to file your federal income tax return.
        By e-filing this form, your tax return will not be due until October 15, 2025 and you will avoid any
        late filing penalties. Any tax balance that you owe should still be paid by April 15 if possible.
        We will confirm with you by email that this extension was successfully e-filed, and if we need more
        information we will reach out by phone. Before submitting this form, confirm that either your
        Prior Year AGI or Prior Year PIN is correct to avoid any delay.
      </div>

      <div class="mt-4 mb-1 ml-2 mr-2 panel-between-desc">
        <div class="form-title mb-1">Payment Details</div>
        Your Form 4868 will be reviewed for any errors and transmitted securely to the IRS electronically.
      </div>

      <div class="panel">
        <div class="credit-wrap">
          <div class="credit-wrap-form" v-if="formValidated">
            <ValidationObserver ref="form5">
              <form autocomplete="off">
                <div class="form-group">
                  <label>Card Holder Name</label>
                  <ValidationProvider
                    name="Card Holder Name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      :class="
                        'form-control ' +
                        (errors.length > 0 ? ' is-invalid' : '')
                      "
                      placeholder="Cardholder Name"
                      v-model="orderInfo.cardHolderName"
                      @blur="onCheckStep5()"
                    />
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <div class="card-num-label">
                    <label>Card Number</label>
                    <div>
                      <img src="@/assets/payment/visa.png" />&nbsp;<img
                        src="@/assets/payment/mastercard.png"
                      />
                    </div>
                  </div>
                  <ValidationProvider
                    name="Card Number"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      :class="
                        'form-control ' +
                        (errors.length > 0 ? ' is-invalid' : '')
                      "
                      placeholder="**** **** **** ****"
                      v-mask="'#### #### #### ####'"
                      v-model="orderInfo.cardNumber"
                      @blur="onCheckStep5"
                    />
                  </ValidationProvider>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label>Expiration Date</label>
                      <ValidationProvider
                        name="Expiration Date"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <input
                          type="text"
                          :class="
                            'form-control ' +
                            (errors.length > 0 ? ' is-invalid' : '')
                          "
                          placeholder="MM/YY"
                          v-mask="'##/##'"
                          autocomplete="off"
                          v-model="card_expire_date"
                          @blur="onCheckStep5"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        >CVC&nbsp;<span
                          class="help-color cursor-pointer"
                          @click="$refs.cardCodeModal.show()"
                          ><font-awesome-icon icon="circle-question" /></span
                      ></label>
                      <ValidationProvider
                        name="CVC"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <input
                          type="password"
                          name="cvc"
                          id="cvc"
                          :class="
                            'form-control ' +
                            (errors.length > 0 ? ' is-invalid' : '')
                          "
                          placeholder="***"
                          autocomplete="cvc"
                          v-mask="'###'"
                          v-model="orderInfo.cardCvc"
                          @blur="onCheckStep5"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div v-for="(message, i) in errorMessages" :key="i">
                  <div class="ein-form-err" v-if="message.show">
                    {{ message.text }}
                  </div>
                </div>
                <div class="btn-checkout" @click="updatePaymentPlanDetails">
                  <img
                    src="@/assets/payment/pay-card.png"
                    class="card-img"
                  />Pay With Card
                </div>
              </form>
            </ValidationObserver>
          </div>
          <div style="flex-grow: 1">
            <div class="brand-wrapper" style="margin-top: -12px">
              <div
                class="brand-images mb-3"
                style="padding-top: 0px !important"
              >
                <img src="@/assets/payment/payment-brand0.png" />
                <img src="@/assets/payment/payment-brand1.png" />
                <img src="@/assets/payment/payment-brand2.png" />
                <img src="@/assets/payment/irs-efile.png" style="max-width: 70px;"/>
              </div>
            </div>
            <div class="price-info">
              <div class="price-item mb-3">
                <div>
                  One-Time Application Fee&nbsp;<span
                    class="help-color"
                    v-b-popover.hover.bottom="
                      'One-Time Enrollment Fee varies by product.'
                    "
                    ><font-awesome-icon icon="circle-question"
                  /></span>
                </div>
                <div>${{ customEnrollmentFee }}.00</div>
              </div>
              <div class="price-item mb-3">
                <div>Subtotal</div>
                <div>${{ subTotal.toFixed(2) }}</div>
              </div>
              <div class="price-item">
                <div style="font-weight: 700">Total</div>
                <div style="font-weight: 700; font-size: 25px">
                  ${{ total.toFixed(2) }}
                </div>
              </div>
            </div>
            <div class="form-group" style="float: right" v-if="formValidated">
              <label class="partner-label"
                >Partner Code<small>(not required)</small></label
              >
              <input
                type="text"
                class="partner-input"
                placeholder="Partner Code"
                v-model="orderInfo.partnerCode"
                v-on:blur="checkPartnerCode()"
              />
            </div>
          </div>
        </div>
        <div
          class="green-landing-button mt-3"
          @click="onClickProcess"
          v-if="!formValidated"
        >
          Proceed to Checkout
        </div>
      </div>

      <div class="mt-2 ml-2 mr-2 price-description" v-if="formValidated">
        The ${{total.toFixed(2)}} will be processed now on the card above. You will receive all further information
        via email. Personal data is never shared or sold and is fully encrypted and secure in accordance with
        our Privacy Policy.
      </div>
    </div>

    <PaymentConfirm
      :amount="total"
      :efile="true"
      v-model="confirmPaymentModal"
      @continuePayment="continuePayment"
      @cancelPayment="cancelPayment"
    ></PaymentConfirm>
    <SalesWidget :phone_number="salesPhoneNumber" v-if="salesPhoneNumber" />
    <b-modal ref="cardCodeModal" title="Card Code" ok-only>
      <p class="my-4">
        The "Card Code" is the 3 digit number on the back of your credit card
        like in the picture below.
      </p>
      <img src="@/assets/whatsthis.jpg" style="max-width: 100%" ok-only />
    </b-modal>
  </page>
</template>

<script>
import { AXIOS } from "../scripts/http-common";
import moment from "moment";
import { SiteUtils } from "../scripts/site-common";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import PaymentConfirm from "./PaymentConfirm.vue";
import SalesWidget from "./../components/SalesWidget.vue";
import { SnackUtils } from "../scripts/snack-common";
import { US_STATES } from "../scripts/constants";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { VueGoogleAutocomplete, PaymentConfirm, Loading },
  data() {
    return {
      salesPhoneNumber: null,
      orderInfo: {
        firstName: "",
        middleName: "",
        lastName: "",
        ssn: "",
        email: "",

        married: false,
        spouseFirstName: "",
        spouseMiddleName: "",
        spouseLastName: "",
        spouseSsn: "",
        abroad: false,

        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",

        totalLiability: "",
        totalPayments: "",

        schedulePayment: false,
        routingTransitNumber: "",
        bankAccountNumber: "",
        bankAccountType: "",
        paymentAmount: "",
        paymentDate: "", // format: 03-14
        phone: "",

        partnerCode: "",
        cardHolderName: "",
        cardNumber: "",
        cardExpMonth: "",
        cardExpYear: "",
        cardCvc: "",

        birthDate: undefined,
        priorYearPin: undefined,
        priorYearAgi: undefined,
        spouseBirthDate: undefined,
        spousePriorYearPin: undefined,
        spousePriorYearAgi: undefined,
      },
      card_expire_date: null,
      formValidated: false,

      isAgiSelected: false,
      isPinSelected: false,
      isSpouseAgiSelected: false,
      isSpousePinSelected: false,

      productPrice: null,
      showAddressTextBox: false,
      percentageOff: 0,
      isProcessing: false,
      confirmPaymentModal: false,
      errorMessages: [],
      jwtData: null,
      error: {
        priorYearPin: false,
        priorYearAgi: false,
        spousePriorYearPin: false,
        spousePriorYearAgi: false,
      },
    };
  },
  created() {
    this.accountTypes = [
      {"value": "1", "name": "Checking"},
      {"value": "2", "name": "Savings"},
    ];
    this.states = US_STATES;

    // Form 4868 should be hidden outside of 01/27 - 04/15
    this.currentYear = this.getCurrentYear();
  },
  methods: {
    handleAgiFocus() {
      if (this.orderInfo.priorYearPin) {
        this.isPinSelected = true;
        this.isAgiSelected = false;
      } else {
        this.isPinSelected = false;
      }
    },
    handlePinFocus() {
      if (this.orderInfo.priorYearAgi) {
        this.isAgiSelected = true;
        this.isPinSelected = false;
      } else {
        this.isAgiSelected = false;
      }
    },
    checkPin($event) {
      if (!this.orderInfo.priorYearPin) {
        this.isPinSelected = false;
      }
    },
    restrictAgi($event) {
      this.orderInfo.priorYearAgi = SiteUtils.validateInputNumber($event);
      if (!this.orderInfo.priorYearAgi) {
        this.isAgiSelected = false;
      }
    },

    handleSpouseAgiFocus() {
      if (this.orderInfo.spousePriorYearPin) {
        this.isSpousePinSelected = true;
        this.isSpouseAgiSelected = false;
      } else {
        this.isSpousePinSelected = false;
      }
    },
    handleSpousePinFocus() {
      if (this.orderInfo.spousePriorYearAgi) {
        this.isSpouseAgiSelected = true;
        this.isSpousePinSelected = false;
      } else {
        this.isSpouseAgiSelected = false;
      }
    },
    checkSpousePin($event) {
      if (!this.orderInfo.spousePriorYearPin) {
        this.isSpousePinSelected = false;
      }
    },
    restrictSpouseAgi($event) {
      this.orderInfo.spousePriorYearAgi = SiteUtils.validateInputNumber($event);
      if (!this.orderInfo.spousePriorYearAgi) {
        this.isSpouseAgiSelected = false;
      }
    },

    getBalanceDue(orderInfo) {
      if (!orderInfo) {
        return 0;
      }
      if (!!orderInfo.totalLiability && !!orderInfo.totalPayments) {
        return orderInfo.totalLiability - orderInfo.totalPayments;
      }
      return 0;
    },

    getCurrentYear() {
      const currentDate = new Date();
      return currentDate.getFullYear();
    },

    async onCheckStep1() {
      const f1_result = this.$refs.form1.validate();
    },
    async onCheckStep2() {
      const f2_result = this.$refs.form2.validate();
    },
    async onCheckStep3() {
      const f3_result = this.$refs.form3.validate();
    },
    async onCheckStep5() {
      const f5_result = this.$refs.form5.validate();
    },

    initializeSalesWidget() {
      AXIOS.get(`/admin/salesList`).then((res) => {
        if (res.status == 200) {
          let list = res.data;
          let index = list.findIndex((it) => {
            let condition_1 =
              it.onOff === true && it.product == "Form 4868";
            let condition_2 = false;
            if (it.startTime && it.endTime) {
              let currentTimeStamp = new Date().getTime();
              let startTimeStamp = new Date(it.startTime).getTime();
              let endTimeStamp = new Date(it.endTime).getTime();
              condition_2 =
                currentTimeStamp > startTimeStamp &&
                currentTimeStamp < endTimeStamp;
            }

            let condition_3 = true;
            let currentTime = moment().tz("America/New_York").format("LT");
            if (!!it.startDaily) {
              let fromTime = moment(it.startDaily).tz("America/New_York").format("LT");
              if (fromTime != "12:00 AM") {
                condition_3 = condition_3 && moment(fromTime, "LT").isBefore(moment(currentTime, "LT"));
              }
            }
            if (!!it.endDaily) {
              let endTime = moment(it.endDaily).tz("America/New_York").format("LT");
              if (endTime != "12:00 AM") {
                condition_3 = condition_3 && moment(currentTime, "LT").isBefore(moment(endTime, "LT"));
              }
            }

            return condition_1 && condition_2 && condition_3;
          });
          if (index > -1) {
            this.salesPhoneNumber = list[index].phoneNumber;
          }
        }
      });
    },

    initializePricings() {
      AXIOS.get(`/admin/productPrice?product_name=Form 4868`).then((res) => {
        if (res.status == 200) {
          console.log(res);
          this.productPrice = res.data.customEnrollmentFee;
          this.ourFee = res.data.customEnrollmentFee;
          this.customEnrollmentFee = res.data.customEnrollmentFee;
        }
      });
    },
    loadOrder() {
      AXIOS.get(`/efile/form4868`).then((response) => {
        this.orderInfo.id = response.data.id;
        this.orderInfo.firstName = response.data.firstName;
        this.orderInfo.middleName = response.data.middleName;
        this.orderInfo.lastName = response.data.lastName;
        this.orderInfo.email = response.data.email;

        this.orderInfo.married = response.data.married;
        this.orderInfo.spouseFirstName = response.data.spouseFirstName;
        this.orderInfo.spouseMiddleName = response.data.spouseMiddleName;
        this.orderInfo.spouseLastName = response.data.spouseLastName;
        this.orderInfo.spouseSsn = response.data.spouseSsn;
        this.orderInfo.abroad = response.data.abroad;

        this.orderInfo.address1 = response.data.address1;
        this.orderInfo.address2 = response.data.address2;
        this.orderInfo.city = response.data.city;
        this.orderInfo.state = response.data.state;
        this.orderInfo.zip = response.data.zip;

        this.orderInfo.totalLiability = response.data.totalLiability;
        this.orderInfo.totalPayments = response.data.totalPayments;

        this.orderInfo.schedulePayment = response.data.schedulePayment;
        this.orderInfo.routingTransitNumber = response.data.routingTransitNumber;
        this.orderInfo.bankAccountNumber = response.data.bankAccountNumber;
        this.orderInfo.bankAccountType = response.data.bankAccountType || "1";
        this.orderInfo.paymentAmount = response.data.paymentAmount;
        this.orderInfo.paymentDate = response.data.paymentDate;
        this.orderInfo.phone = response.data.phone;
      });
    },

    checkPartnerCode() {
      if (!this.orderInfo.partnerCode) {
        this.orderInfo.amount = (this.total * 100).toString();
      } else {
        this.isProcessing = true;
        AXIOS.get(`/paymentplan/partnercodes/${this.orderInfo.partnerCode}`)
          .then((res) => {
            if (res.data && !Number.isNaN(res.data.percentageOff)) {
              this.percentageOff = res.data.percentageOff;
            } else {
              this.percentageOff = 0;
            }
          })
          .catch((err) => {
            this.percentageOff = 0;
          })
          .finally(() => {
            this.isProcessing = false;
            this.orderInfo.amount = (this.total * 100).toString();
          });
      }
    },

    getAddressData: function (addressData, placeResultData, id) {
      console.log("-----------------");
      console.log(addressData);
      this.orderInfo.address1 = addressData.street_number
        ? addressData.street_number + " " + addressData.route
        : addressData.route;

      this.orderInfo.address2 = addressData.subpremise || "";

      document.getElementById("gaddress").value =
        this.orderInfo.address1;

      this.orderInfo.city = addressData.locality
        ? addressData.locality
        : placeResultData.vicinity
        ? placeResultData.vicinity
        : placeResultData.address_components[3].long_name;

      this.orderInfo.state = addressData.administrative_area_level_1
        ? addressData.administrative_area_level_1
        : "";

      this.orderInfo.zip = addressData.postal_code
        ? addressData.postal_code
        : "";

      this.showAddressTextBox = false;
    },
    extractAddress: function () {
      console.log("blur", this.orderInfo.address1);
      google.maps.places.Autocomplete(this.getAddressData, "place_changed");
      //this.showAddressTextBox=false;

      if (this.orderInfo.address1 != "") {
        this.showAddressTextBox = false;
      }
    },
    setAddress: function (address, type) {
      this.orderInfo.address1 = address.newVal
        ? address.newVal.split(",")[0]
        : "";
    },
    changeToAddressGoogle: function () {
      this.showAddressTextBox = true;
      document.getElementById("gaddress").focus();
    },

    async onClickProcess() {
      console.log("-----onClickProcess---");

      let f1_result = await this.$refs.form1.validate();
      let f2_result = await this.$refs.form2.validate();
      let f3_result = await this.$refs.form3.validate();

      let checkOptions = true;
      this.error = {
        priorYearPin: false,
        priorYearAgi: false,
        spousePriorYearPin: false,
        spousePriorYearAgi: false,
      };

      if ((this.orderInfo.priorYearAgi === undefined || this.orderInfo.priorYearAgi.length === 0)
        && (this.orderInfo.priorYearPin === undefined || this.orderInfo.priorYearPin.length === 0)) {
        this.error.priorYearAgi = "* One of the fields is required";
        this.error.priorYearPin = "* One of the fields is required";
        checkOptions = false;
      } else if (!!this.orderInfo.priorYearPin) {
        let checkPriorYearPinErrorMsg = SiteUtils.validatePIN(this.orderInfo.priorYearPin);
        if (checkPriorYearPinErrorMsg) {
          this.error.priorYearPin = checkPriorYearPinErrorMsg;
          checkOptions = false;
        }
      }

      if (this.orderInfo.married) {
        let checkSpouseBirthDateErrorMsg = SiteUtils.validateBirthDate(this.orderInfo.spouseBirthDate);
        if (checkSpouseBirthDateErrorMsg) {
          this.error.spouseBirthDate = checkSpouseBirthDateErrorMsg;
          checkOptions = false;
        }

        if ((this.orderInfo.spousePriorYearAgi === undefined || this.orderInfo.spousePriorYearAgi.length === 0)
          && (this.orderInfo.spousePriorYearPin === undefined || this.orderInfo.spousePriorYearPin.length === 0)) {
          this.error.spousePriorYearAgi = "** One of the fields is required";
          this.error.spousePriorYearPin = "** One of the fields is required";
          checkOptions = false;
        } else if (!!this.orderInfo.spousePriorYearPin) {
          let checkSpousePriorYearPinErrorMsg = SiteUtils.validatePIN(this.orderInfo.spousePriorYearPin);
          if (checkSpousePriorYearPinErrorMsg) {
            this.error.spousePriorYearPin = checkSpousePriorYearPinErrorMsg;
            checkOptions = false;
          }
        }
      }

      this.formValidated = f1_result && f2_result && f3_result && checkOptions;
      if (!this.formValidated) {
        SnackUtils.warning(
          "Please fill invalid fields above."
        );
      }
    },
    onPaymentSuccess() {},

    postFailureReason() {
      AXIOS.put(`/efile/form4868/fail`, this.orderInfoTemp)
        .then((response) => {})
        .catch((error) => {
          console.log(error);
        });
    },

    initializeCardinal() {
      let orderInfo = Object.assign({}, this.orderInfo);

      if (!window.cardinalIsInitialized) {
        Cardinal.configure({
          logging: {
            debug: "verbose",
            timeout: 10000,
          },
        });
        window.cardinalIsInitialized = true;
      }
      let self = this;

      Cardinal.off("payments.setupComplete");
      Cardinal.off("payments.validated");

      Cardinal.on("payments.setupComplete", () => {
        Cardinal.start("cca", self.jwtData.payload);
      });

      Cardinal.on("payments.validated", (data, jwt) => {
        if (data.ActionCode === "SUCCESS" || data.ActionCode === "NOACTION") {
          self.$set(self.orderInfo, "responseJwt", jwt);

          self.orderInfoTemp.amount = (
            (this.total - self.discount) *
            100
          ).toString();

          let orderForPdf = Object.assign({}, self.orderInfoTemp);
          orderForPdf.orderNumber = self.orderNumber;
          orderForPdf.responseJwt = jwt;

          AXIOS.post(`/efile/form4868/authorize`, orderForPdf)
            .then((response) => {
              if (response.data.success) {
                window.location.href =
                  "/form4868-confirmation/" +
                  response.data.correlationId;
              } else {
                this.orderInfoTemp.failureReason = response.data.message;
                self.errorMessages.push({
                  show: true,
                  text: response.data.message,
                });
                this.initializeCardinal();
                self.isProcessing = false;

                if (this.orderInfoTemp.failureReason) {
                  this.postFailureReason();
                }
              }
            })
            .catch((e) => {
              if (e.response.status === 409) {
                this.orderInfoTemp.failureReason = "Possible duplicate";
                self.errorMessages.push({
                  show: true,
                  text: "Sorry, it looks like you may have already placed an order with us! Please <a href='/contact-us'>contact us</a> for help.",
                });
                self.isProcessing = false;
              } else {
                this.orderInfoTemp.failureReason = "Error!";
                self.errorMessages.push({
                  show: true,
                  text: "Unable to make purchase. Please check your payment details or try a different payment method.",
                });
                this.initializeCardinal();
                self.isProcessing = false;
              }

              if (this.orderInfoTemp.failureReason) {
                this.postFailureReason();
              }
            });
        } else {
          this.orderInfoTemp.failureReason =
            "3D Secure Failed: Your card was unable to be authenticated. Please check your information or use a different card and try again.";
          self.errorMessages.push({
            show: true,
            text: "3D Secure Failed: Your card was unable to be authenticated. Please check your information or use a different card and try again.",
          });
          this.initializeCardinal();
          self.isProcessing = false;
        }

        if (this.orderInfoTemp.failureReason) {
          this.postFailureReason();
        }
      });
    },

    updatePaymentPlanDetails() {
      console.log("---------");
      this.$refs.form5.validate().then((success) => {
        console.log(success);
        if (success) {
          this.confirmPaymentModal = true;
        } else {
          SnackUtils.warning("Please fill the fields in payment form.");
        }
      });
    },
    continuePayment() {
      this.confirmPaymentModal = false;
      this.isProcessing = true;

      this.orderInfoTemp = Object.assign({},this.orderInfo);
      this.orderInfoTemp.amount = (this.total * 100).toString();

      console.log(this.orderInfoTemp);
      AXIOS.put(`/efile/form4868`, this.orderInfoTemp)
        .then((result) => {
          const { id, correlationId } = result.data;
          this.postOrderInfo(id, correlationId);
        })
        .catch((err) => {
          this.isProcessing = false;
          alert(err);
          console.log(err);
        });
    },
    cancelPayment() {
      // let order=Object.assign({},this.orderInfo)
      this.orderInfoTemp.amount = (this.total * 100).toString();

      this.isProcessing = false;
      this.orderInfoTemp.failureReason = "Payment Confirmation Declined";
      this.postFailureReason();
    },

    postOrderInfo(orderNum, correlationId) {
      this.errorMessages = [];
      this.isProcessing = true;

      this.orderInfo.phone = SiteUtils.standardizePhone(
        this.orderInfo.phone
      );
      this.orderInfoTemp.ssn = SiteUtils.standardizeSsn(this.orderInfo.ssn);
      this.orderInfoTemp.cardNumber = this.orderInfo.cardNumber.replace(
        /[^0-9]/g,
        ""
      );

      let curDate = new Date();
      let curYear = curDate.getFullYear().toString().substring(0, 2);
      this.orderInfoTemp.cardExpMonth = this.card_expire_date.substring(0, 2);
      this.orderInfoTemp.cardExpYear =
        curYear + this.card_expire_date.substring(3, 5);

      this.orderInfoTemp.amount = (this.total * 100).toString();

      let self = this;
      AXIOS.post(`/efile/form4868/jwt`, this.orderInfoTemp)
        .then((response) => {
          self.$set(self, "jwtData", response.data);
          self.orderNumber = response.data.payload.OrderDetails.OrderNumber;
          Cardinal.setup("init", {
            jwt: self.jwtData.jwt,
          });
        })
        .catch((e) => {
          console.log(e);
          self.errorMessages.push({
            show: true,
            text: "Unexpected error occurred. Please try again later.",
          });
          this.initializeCardinal();
          self.isProcessing = false;
        });
    },
  },
  computed: {
    subTotal: function () {
      /*
      return (
        this.enrollmentFee +
        this.processingFee +
        this.payrollDeductionFee +
        this.changeOfAddressFee
      );*/
      return this.productPrice;
    },
    total: function () {
      return this.subTotal - this.discount;
    },
    discount: function () {
      return this.subTotal * (this.percentageOff / 100);
    },
  },
  mounted() {
    this.initializeSalesWidget();
    this.initializeCardinal();

    this.initializePricings();
    window.ANS_customer_id = "d7332b5b-b0c5-4072-9237-bef8a02352ae";
    this.loadOrder();
  },
};
</script>

<style scoped>
.banner {
  background: #f8faf9;
  padding: 50px 0px 0px 0px;
}
.title {
  margin: 0 auto;
  width: 100%;
  max-width: 620px;
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 60px;
  line-height: 74px;
  text-align: center;

  color: #252020;
}
@media only screen and (max-width: 862px) {
  .title {
    font-size: 48px;
    line-height: 58px;
  }
}
.green-underline {
  text-decoration: underline;
  text-decoration-color: #2ac44c;
}
.green-color {
  color: #2ac44c;
}
.the-title {
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 150%;

  color: #252020;
}
.the-sub-title {
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;

  color: #252020;
}

.checkout-img {
  text-align: center;
  position: relative;
}

.checkout-form {
  background: white;
  padding: 0px 0px 40px 0px;
  max-width: 872px;
  width: 100%;
  margin: 0 auto;
}

.form-title {
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 150%;

  /* text-align: center; */
  color: #252020;
}

.mt-10 {
    margin-top: 4.5rem !important;
}

.form-desc {
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: #252020;
}

.circle-price {
  position: absolute;
  left: 50%;
  top: 72px;
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 31.2849px;
  line-height: 38px;
  text-align: center;
  transform: translateX(-50%);

  color: #ffffff;
}

.stepper-graph {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
}

.stepper-circle {
  z-index: 999;
  background: #d9d9d9;
  width: 48px;
  height: 48px;
  border-radius: 50%;

  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;

  color: #ffffff;

  text-align: center;
  padding-top: 11px;
  position: relative;
}

.stepper-active {
  background: #2ac44c;
}

.bg-line {
  width: 100%;
  background: #d9d9d9;
  height: 4px;
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
}

.active-line-wrapper {
  background: #d9d9d9;
  height: 4px;
  position: absolute;
  left: 24px;
  width: calc(100% - 48px);
  top: 50%;
  transform: translateY(-50%);
}

.active-line {
  height: 4px;
  background: #2ac44c;
}

.panel {
  background: #f5f5f5;
  padding: 40px;

  border: 1px solid #d9d9d9;
  border-radius: 12px;
}

.panel-active {
  border: 1px solid #2ac44c;
}

.blue-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  gap: 10px;
  flex-wrap: wrap;

  background: rgba(42, 150, 196, 0.2);
  border-radius: 6px;

  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 10px;
}

.blue-item-value {
  width: 160px;
}

.brand-wrapper {
  max-width: 460px;
  width: 100%;
  margin: 0 auto;
}

.price-info {
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  flex-grow: 1;
}

.btn-checkout {
  width: 100%;
  padding: 20px 40px;

  background: #2ac44c;
  border-radius: 8px;

  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;

  color: #ffffff;

  text-align: center;

  cursor: pointer;
  position: relative;
}

.card-img {
  position: absolute;
  left: 30px;
  top: 50%;
  width: 24px;
  transform: translateY(-50%);
}

.credit-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  gap: 20px;
  align-items: flex-end;
}

.credit-wrap-form {
  max-width: 360px;
  width: 100%;
}

@media screen and (max-width: 703px) {
  .credit-wrap-form {
    max-width: 100%;
    width: 100%;
  }
}

.card-num-label {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.price-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.good-news {
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #817e7e;
}

.panel-between-desc {
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;

  color: #252020;
}

.price-description {
  font-family: "PT Sans", serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 25px;
  text-align: center;
  color: #716060;
}

.step-desc {
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #252020;
  display: block;
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  top: 100%;
}

.mt80 {
  margin-top: 80px;
}

.cursor-pointer {
  cursor: pointer;
}

.bold-font {
  font-weight: bold;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e5e5e5 !important;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #e5e5e5 !important;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #e5e5e5 !important;
}
.partner-label {
  font-size: 0.8rem;
}
.partner-input {
  width: 110px;
  display: block;
  border: 1px solid #b3b3b3;
  font-size: 0.8rem;
  border-radius: 3px;
}
.text-entered {
  color: #0fb153;
  font-weight: bold;
  font-size: large;
  margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Form4868Checkout.vue